// AI 추천 프롬프트에 추가할 수 있는 "여행 컨셉" 목록.
// 각 항목은 { id, label, prompt } — label은 칩에 표시하는 짧은 이름,
// prompt는 AIPromptModal이 프롬프트의 "여행 컨셉" 항목에 그대로 붙여 넣는 지시문이다.
export const AI_CONCEPTS = [
  {
    id: "food",
    label: "식도락",
    prompt:
      "식사를 여행의 중심으로 한다. 현지 대표 음식점·시장·길거리 음식 위주로, 식사 시간대(점심 11~13시, 저녁 17~19시)에 맞춰 배치하고 웨이팅·예약 필요 여부는 메모에 적는다.",
  },
  {
    id: "cafe",
    label: "카페 투어",
    prompt:
      "카페를 중심으로 하루 2~4곳을 넣는다. 로스터리·뷰 카페·디저트 맛집을 섞고 카페 사이 이동이 짧은 동선으로 하며 대표 메뉴는 메모에 적는다.",
  },
  {
    id: "themepark",
    label: "놀이동산·테마파크",
    prompt:
      "하루를 테마파크에 집중한다. 개장·폐장 시간을 기준으로 구성하고 입장권·예약 필요 여부, 인기 어트랙션 우선순위, 식사·휴식 시간을 메모에 적는다.",
  },
  {
    id: "shopping",
    label: "쇼핑",
    prompt:
      "쇼핑을 중심으로 한다. 현지 인기 쇼핑가·아울렛·로컬 브랜드 매장을 영업시간에 맞춰 배치하고 면세·택스리펀 팁은 메모에 적는다.",
  },
  {
    id: "nature",
    label: "자연·힐링",
    prompt:
      "자연과 휴식 중심으로 일정 밀도를 낮추고, 공원·온천·산책로를 넣으며 이동은 최소화한다.",
  },
  {
    id: "history",
    label: "역사·문화",
    prompt:
      "역사·문화 명소와 박물관 중심으로 하되 휴관일과 입장 마감 시간을 메모에 적는다.",
  },
  {
    id: "photo",
    label: "사진 명소",
    prompt:
      "사진이 잘 나오는 명소 중심으로, 빛이 좋은 시간대(오전·일몰 전후)에 맞춰 배치한다.",
  },
  {
    id: "nightview",
    label: "야경·전망",
    prompt: "일몰 시간에 맞춰 전망대와 야경 명소를 저녁에 배치한다.",
  },
  {
    id: "activity",
    label: "액티비티·체험",
    prompt:
      "체험 활동(클래스, 투어, 액티비티) 중심으로 하되 예약 필요 여부와 소요 시간을 메모에 적는다.",
  },
  {
    id: "localmarket",
    label: "로컬 시장·골목",
    prompt:
      "현지 시장과 골목 산책 중심으로, 아침~점심의 시장과 저녁의 골목 가게를 배치한다.",
  },
  {
    id: "petfriendly",
    label: "반려동물 동반",
    prompt:
      "반려동물과 함께 다닐 수 있는 장소(반려동물 동반 가능 공원·카페·식당) 위주로 구성하고, 동반 가능 여부와 제한사항(목줄, 입장 제한 등)은 메모에 적는다.",
  },
  {
    id: "family",
    label: "가족·아이 동반",
    prompt:
      "아이와 함께 다니기 좋은 장소(놀이터, 체험 공간, 짧은 동선) 위주로 구성하고 유모차 이용 가능 여부와 아이 휴식 시간을 고려해 배치한다.",
  },
  {
    id: "mustsee",
    label: "대표 명소 필수",
    prompt:
      "그 도시의 대표 명소는 반드시 포함한다. 처음 가는 사람을 기준으로 필수 코스를 우선 배치한다.",
  },
];

// 프롬프트 [작성 규칙]의 "하루 N개 일정" 문구를 고르는 3단계 일정 밀도.
// "보통"의 문구는 기존 기본 규칙과 완전히 같다 — 밀도를 선택하지 않은 것처럼
// 보여야 하는 기본값이기 때문(여행 컨셉 미선택 시 프롬프트가 기존과 같아야 하는
// 규칙과 같은 이유).
export const DENSITY_OPTIONS = [
  { id: "light", label: "여유", prompt: "하루 1~2개 주요 일정만 여유롭게 구성한다." },
  { id: "normal", label: "보통", prompt: "하루 2~4개 주요 일정만 구성한다." },
  { id: "packed", label: "빡빡", prompt: "하루 4~6개 일정을 빡빡하게 구성한다." },
];
